import React from "react";
import { ExcelDocsPreview } from "./components/ExcelDocsPreview";

interface IDocumentPreviewContext {
  previewExcelDocsFile: (paths: string[]) => void;
}

const FileUploadContext = React.createContext<IDocumentPreviewContext>({
    previewExcelDocsFile: () => {},
});

export const useFileUpload = () => React.useContext(FileUploadContext);

export const FileUploadProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {

    const [openExeclDocsPreview, setOpenExcelDocsPreview] = React.useState<string[] | null>(null);

    const handlePreviewExcelDocsFile = (paths: string[]) => {
        setOpenExcelDocsPreview(paths);
    }

    return(
        <>
          <FileUploadContext.Provider value={{
            previewExcelDocsFile: handlePreviewExcelDocsFile
          }}>
            {children}
            {openExeclDocsPreview && (
              <ExcelDocsPreview
                open={true}
                path={openExeclDocsPreview}
                onClose={() => setOpenExcelDocsPreview(null)}
              />
            )}
          </FileUploadContext.Provider>
        </>
    )
}